export const invoiceMngRouter = [
  // 发票列表
  {
    path: '/invoiceMng/invoiceList',
    name: 'invoiceList',
    component: () => import('../views/invoiceMng/invoiceList')
  },
]